import { useCallback, useSyncExternalStore } from "react";
import { useQueryClient } from "@tanstack/react-query";

const STORAGE_KEY = "komoran-active-store";

const listeners = new Set<() => void>();

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

function getSnapshot(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

function setStore(id: string | null) {
  if (id) {
    localStorage.setItem(STORAGE_KEY, id);
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
  listeners.forEach((cb) => cb());
}

export function useActiveStore() {
  const queryClient = useQueryClient();
  const storeId = useSyncExternalStore(subscribe, getSnapshot);

  const setStoreId = useCallback((id: string | null) => {
    setStore(id);
    queryClient.removeQueries();
  }, [queryClient]);

  return { storeId, setStoreId };
}
